import React from 'react';
import type { LucideIcon } from 'lucide-react';
import { X } from 'lucide-react';

/** A side-dock panel's frame: a head row on the app's line (icon, title, close) and a
 *  scrolling body. Pages use it for the panels they put in the dock. */
export const DockPane: React.FC<{
  icon: LucideIcon;
  title: string;
  onClose: () => void;
  actions?: React.ReactNode;
  children: React.ReactNode;
}> = ({ icon: Icon, title, onClose, actions, children }) => (
  <section className="dock-pane" aria-label={title}>
    <header className="dock-pane-head">
      <Icon size={15} />
      <h2>{title}</h2>
      {actions}
      <button type="button" className="dock-pane-x" onClick={onClose} title="Хаах" aria-label="Хаах"><X size={15} /></button>
    </header>
    <div className="dock-pane-body">{children}</div>
  </section>
);
